import React from 'react';

import { getVideos, getVideo } from './services';

import Loading from 'react-simple-loading';
import VideosGrid from './VideosGrid/VideosGrid';
import VideosCount from './VideosCount/VideosCount';
import ReactPaginate from 'react-paginate';
import VideoPreview from './VideoPreview/VideoPreview';
import NoData from '../../../components/generalComponents/NoData/NoData';

import './css/AnchorVideosArchive.css';
import AnchorDashboardHeader from '../../../components/AnchorDashboardHeader/AnchorDashboardHeader';

class AnchorVideosArchive extends React.Component {

  state = {
    videos: [],
    video: null,
    loading: true,
    pagination: {
      total: 0,
      offset: 0,
      limit: 12
    }
  }

  componentDidMount () {
    this.loadBasedOnUrlParam();
  }

  componentDidUpdate (prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.setState({video: null}, ()=>{
        this.loadBasedOnUrlParam();
      })
    }
  }

  loadBasedOnUrlParam () {
    const { match: { params: { id } }, history } = this.props;
    if (id !== undefined) {
      if (!isNaN(Number(id))) {
        this.getVideo(id);
      } else {
        history.replace('/videos');
      }
    } else {
      this.getVideos()
    }
  }

  getVideo = videoId => {
    this.setState({ loading: true }, () => {
      const { user: { account: { anchor: { id } } } } = this.props.user;
      getVideo({ id, videoId })
        .then(data => {
          this.setState({ loading: false, video: data.data });
        })
    });
  }

  getVideos = () => {
    this.setState({ loading: true }, () => {
      const { user: { account: { anchor: { id } } } } = this.props.user;
      const { offset, limit } = this.state.pagination;
      getVideos({ id, params: { offset, limit } })
        .then(data => {
          const pagination = { ...this.state.pagination };
          pagination.total = data.data.videoCount;
          this.setState({ loading: false, videos: data.data.videoList, pagination });
        })
    })
  }

  handlePageChanged = data => {
    this.setState(state => {
      return {
        pagination: { ...state.pagination, offset: data.selected * state.pagination.limit }
      }
    }, () => {
      this.getVideos();
    });
  }

  renderLoadingScreen () {
    return (
      <div id="anchor-video-archive-loading">
        <Loading color="black" size={'48px'} stroke={'2px'} />
      </div>
    );
  }

  renderVideo () {
    const { video } = this.state;
    const { user } = this.props;
    return video && (
      <VideoPreview video={video} user={user} />
    );
  }

  renderVideos () {
    const { videos, pagination: { total, limit } } = this.state;
    const { user } = this.props.user;
    return (
      <div id="anchor-videos-archive" className="anchor-private-videos">
        <div className="container">
          <VideosGrid
            user={user}
            videos={videos}
            getVideos={this.getVideos}
          />
          <div className="videos-count">
            <VideosCount count={total} ready={!this.state.loading} />
          </div>
          {total > limit && (
            <div className="flex justify-center">
              <ReactPaginate
                containerClassName={'pagination'}
                pageCount={10}
                pageRangeDisplayed={5}
                marginPagesDisplayed={2}
                onPageChange={this.handlePageChanged}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  render () {
    const { loading, videos } = this.state;
    const { match: { params: { id } } } = this.props;
    const noData = videos.length === 0 && (id === null || id === undefined);
    return (
      <div id="anchor-videos-archive" className="anchor-dashboard-min-height">
        <AnchorDashboardHeader heading={'My Videos'} />
        {loading && this.renderLoadingScreen()}
        {id || id === 0 ? this.renderVideo() : this.renderVideos()}
        {noData ? <NoData category="videos" /> : null}
      </div>
    );
  }
}

export default AnchorVideosArchive;